import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './dataLeakage.less';
import './dataLeakage-en.less';
import './dataLeakage.theme.less';

export interface DataLeakageProps {
  topicName: string;
  topicSettings: any[];
}

export function DataLeakage(props: DataLeakageProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
